import { IconBuildingsFilled } from '@zillow/constellation-icons';
import type {
  ClientAdProductType,
  PortfolioAnalyticsPropertyResponseDto,
} from '@zg-rentals/ts-customer-analytics-client';
import { mapPackageTypeName } from '../../../../utils/mapPackageTypeName';
import type { DisplayingRegionLevel } from '../../../../types/DisplayingRegionLevel';
import { regionsWithMarkers } from './AdSpendMap.hooks';
import { PACKAGE_COLORS } from '../../../SharedComponents/Map/Dots/Dots.consts';
import { MapControls as SharedMapControls } from '../../../SharedComponents/Map/MapControls';

export const AdSpendMapControls = ({
  hiddenPackages,
  setHiddenPackages,
  allPackages,
  finalDisplayMode,
  propertiesByPackageType,
}: {
  hiddenPackages: Array<ClientAdProductType>;
  setHiddenPackages: (hiddenPackages: Array<ClientAdProductType>) => void;
  allPackages: Array<ClientAdProductType>;
  finalDisplayMode: DisplayingRegionLevel;
  propertiesByPackageType: Record<ClientAdProductType, Array<PortfolioAnalyticsPropertyResponseDto>>;
}) => {
  if (allPackages.length === 0 || !regionsWithMarkers.includes(finalDisplayMode)) return null;

  const sections = [
    {
      title: 'Show by package type',
      controls: allPackages.map((packageType) => ({
        backgroundColor: PACKAGE_COLORS[packageType] || '#111116',
        icon: <IconBuildingsFilled />,
        title: mapPackageTypeName(packageType),
        checked: !hiddenPackages.includes(packageType),
        onChange: () => {
          const isAlreadyHidden = hiddenPackages.includes(packageType);
          if (isAlreadyHidden) {
            setHiddenPackages(hiddenPackages.filter((p) => p !== packageType));
          } else {
            setHiddenPackages([...hiddenPackages, packageType]);
          }
        },
        items: propertiesByPackageType[packageType] || [],
      })),
    },
  ];

  return <SharedMapControls sections={sections} />;
};
